// extracted by mini-css-extract-plugin
module.exports = {"table":"AdminUsersPage_table__NEo_T","inactive":"AdminUsersPage_inactive__3H2dP"};